<template>
  <div class="gantt-elastic__header" :style="{ ...style['header'] }">
    <el-row style="width:100%">
      <el-col :span="10">
        <slot name="from"></slot>
      </el-col>
      <el-col :span="14">
        <div style="height: 32px;" class="d-flex align-items-center">
          <div
            class="gantt-elastic__header-options"
            :style="{ ...style['header-options'] }"
          >
            <!-- <b-button
            class="gantt-elastic__header-btn-recenter mr-3"
            size="sm"
            variant="outline-primary"
            @click.prevent="recenterPosition"
          >
            当前
          </b-button> -->
            <label
              class="gantt-elastic__header-label mr-3"
              :style="{ ...style['header-label'] }"
            >
              <span class="mr-1">
                列宽比例
              </span>
              <div
                class="gantt-elastic__header-slider-wrapper"
                :style="{ ...style['header-slider-wrapper'] }"
              >
                <vue-slider
                  class="gantt-elastic__header-slider"
                  tooltip="none"
                  :style="{ ...style['header-slider'] }"
                  :process-style="{ ...style['header-slider--process'] }"
                  :slider-style="{ ...style['header-slider--slider'] }"
                  v-model="scale"
                  :max="24"
                  :min="2"
                  width="80px"
                ></vue-slider>
              </div>
            </label>
            <label
              class="gantt-elastic__header-label mr-3"
              :style="{ ...style['header-label'] }"
            >
              <span class="mr-1">
                列高比例
              </span>
              <div
                class="gantt-elastic__header-slider-wrapper"
                :style="{ ...style['header-slider-wrapper'] }"
              >
                <vue-slider
                  class="gantt-elastic__header-slider"
                  tooltip="none"
                  :style="{ ...style['header-slider'] }"
                  :process-style="{ ...style['header-slider--process'] }"
                  :slider-style="{ ...style['header-slider--slider'] }"
                  v-model="height"
                  :max="100"
                  :min="7"
                  width="80px"
                ></vue-slider>
              </div>
            </label>
            <label
              class="gantt-elastic__header-label mr-3"
              :style="{ ...style['header-label'] }"
            >
              <span class="mr-1">
                任务列表宽度
              </span>
              <div
                class="gantt-elastic__header-slider-wrapper"
                :style="{ ...style['header-slider-wrapper'] }"
              >
                <vue-slider
                  class="gantt-elastic__header-slider"
                  tooltip="none"
                  :style="{ ...style['header-slider'] }"
                  :process-style="{ ...style['header-slider--process'] }"
                  :slider-style="{ ...style['header-slider--slider'] }"
                  v-model="scope"
                  :max="31"
                  :min="0"
                  width="80px"
                ></vue-slider>
              </div>
            </label>
            <label
              class="gantt-elastic__header-label mr-3"
              :style="{ ...style['header-label'] }"
            >
              <span class="mr-1">
                任务列表大小
              </span>
              <div
                class="gantt-elastic__header-slider-wrapper"
                :style="{ ...style['header-slider-wrapper'] }"
              >
                <vue-slider
                  class="gantt-elastic__header-slider"
                  tooltip="none"
                  :style="{ ...style['header-slider'] }"
                  :process-style="{ ...style['header-slider--process'] }"
                  :slider-style="{ ...style['header-slider--slider'] }"
                  v-model="divider"
                  :max="100"
                  :min="0"
                  width="80px"
                ></vue-slider>
              </div>
            </label>
            <label
              class="gantt-elastic__header-task-list-switch--wrapper"
              :style="{ ...style['header-task-list-switch--label'] }"
            >
              <switches
                class="gantt-elastic__header-task-list-switch"
                :style="{ ...style['header-task-list-switch'] }"
                v-model="root.state.options.taskList.display"
              ></switches>
              显示任务列表
            </label>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import vueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import Switches from 'vue-switches'
export default {
  components: { vueSlider, Switches },
  inject: ['root'],
  data() {
    return {
      scaleTimeoutId: null,
      firstScale: false,
      localScale: 0,
      localHeight: 0,
      localBefore: 0,
      localPercent: 0,
      style: {
        header: {
          margin: '0px auto',
          background: '#f3f5f747',
          padding: '10px',
          overflow: 'hidden',
          clear: 'both',
        },
        // 'header-options': { height: '32px' },
        'header-title--text': {
          'font-size': '20px',
          'vertical-align': 'middle',
          'font-weight': '400',
          'line-height': '40px',
          'padding-left': '22px',
          'letter-spacing': '1px',
        },
        'header-title--html': {
          'font-size': '20px',
          'vertical-align': 'middle',
          'font-weight': '400',
          'line-height': '35px',
          'padding-left': '22px',
          'letter-spacing': '1px',
        },
        'header-btn-recenter': {
          background: '#95A5A6',
          border: 'none',
          outline: 'none',
          cursor: 'pointer',
          color: 'white',
          'border-radius': '3px',
          'margin-right': '27px',
          'font-size': '16px',
          padding: '8px 12px',
        },
        'header-slider': {
          'box-sizing': 'content-box',
        },
        'header-slider-wrapper': {
          display: 'inline-block',
          'vertical-align': 'middle',
        },
        'header-slider--slider': { 'box-sizing': 'content-box' },
        'header-slider--process': { 'box-sizing': 'content-box' },
        'header-task-list-switch--label': { 'box-sizing': 'content-box' },
        'header-task-list-switch': {
          margin: '0px 10px',
          'vertical-align': 'middle',
        },
        'header-label': {},
      },
      opts: {},
    }
  },
  created() {
    this.localScale = this.root.state.options.times.timeZoom
    this.localHeight = this.root.state.options.row.height
    this.localBefore = this.root.state.options.scope.before
    this.localPercent = this.root.state.options.taskList.percent
  },
  methods: {
    getImage() {
      this.root.getImage('image/png').then((imgB64) => {
        const link = document.createElement('a')
        link.href = imgB64
        link.download = 'gantt-elastic.png'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },
    recenterPosition() {
      this.root.$emit('recenterPosition')
    },
    setScale(value) {
      if (this.scaleTimeoutId !== null) {
        clearTimeout(this.scaleTimeoutId)
        this.scaleTimeoutId = null
      }
      if (this.firstScale) {
        this.scaleTimeoutId = setTimeout(() => {
          this.root.$emit('times-timeZoom-change', value)
          this.scaleTimeoutId = null
        }, 50)
      } else {
        this.root.$emit('times-timeZoom-change', value)
        this.firstScale = true
      }
    },
  },
  computed: {
    scale: {
      get() {
        return this.localScale
      },
      set(value) {
        this.localScale = Number(value)
        this.setScale(this.localScale)
      },
    },
    height: {
      get() {
        return this.localHeight
      },
      set(value) {
        this.localHeight = Number(value)
        this.root.$emit('row-height-change', Number(value))
      },
    },
    scope: {
      get() {
        return this.localBefore
      },
      set(value) {
        this.localBefore = Number(value)
        this.root.$emit('scope-change', Number(value))
      },
    },
    divider: {
      get() {
        return this.localPercent
      },
      set(value) {
        this.localPercent = Number(value)
        this.root.$emit('taskList-width-change', Number(value))
      },
    },
  },
}
</script>
<style scoped>
.gantt-elastic__header {
  font-size: 13px;
}
</style>
